/* eslint-disable no-shadow */
import { guestOperationsSeatAllocationApi } from '@/app/shared/services/apis/guestOperationsSeatAllocationApi.service';

const mapLabelSettings = (labelSettings) => {
    const object2Array = (object) =>
        Object.entries(object).map(([key, value]) => ({
            id: value,
            name: key,
        }));

    return {
        labelTypes: object2Array(labelSettings.label_type.data),
        document: {
            format: object2Array(labelSettings['document.format'].data),
            print: Object.entries(labelSettings['document.print'].data).reduce(
                (object, [key, value]) => ({
                    ...object,
                    [key]: object2Array(value),
                }),
                {}
            ),
        },
    };
};

const state = () => ({
    labelSettings: {},
    loading: false,
    selectedLabelTypeId: null,
});

const getters = {
    labelSettings(state) {
        return state.labelSettings;
    },
    loadingLabelSettings(state) {
        return state.loading;
    },
    selectedLabelTypeId(state) {
        return state.selectedLabelTypeId;
    },
    labelTypes(state, getters) {
        return getters.labelSettings?.labelTypes ?? [];
    },
    getPrintSettings: (state, getters) => (labelTypeId) => {
        return (
            getters.labelSettings?.document?.print?.[labelTypeId ?? getters.selectedLabelTypeId] ??
            []
        );
    },
    formatSettings(state, getters) {
        return getters.labelSettings?.document?.format ?? [];
    },
};

const actions = {
    async loadLabelSettings({ commit }, { eventId }) {
        commit('setLoadingLabelSettings', true);

        try {
            const labelSettings = mapLabelSettings(
                await guestOperationsSeatAllocationApi.getLabelSettings(eventId)
            );
            commit('setlabelSettings', labelSettings);
        } finally {
            commit('setLoadingLabelSettings', false);
        }
    },
    selectLabelOption({ commit }, { labelOptionId }) {
        commit('setSelectedLabelOptionId', labelOptionId);
    },
};

const mutations = {
    setlabelSettings(state, labelSettings) {
        state.labelSettings = labelSettings;
    },
    setLoadingLabelSettings(state, loading) {
        state.loading = loading;
    },
    setSelectedLabelOptionId(state, labelOptionId) {
        state.selectedLabelTypeId = labelOptionId;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
